export default {
    mutations: {
        setEchoClient(state, echoClient) {
            state.echoClient = echoClient;
        },
    },
    state: {
        echoClient: null,
    },
    getters: {
        getEchoClient(state) {
            return state.echoClient;
        },
    }
}